$(document).ready(function($) {
    $('.brand-slider').each(function() {
        var children = $(this).find('.slide-holder >.acf-innerblocks-container').children();
        //add to the style tag the number of children
        var currentStyle = $(this).find('.slide-holder').attr('style');
        $(this).find('.slide-holder').attr('style', currentStyle + '--quantity: ' + children.length + ';');
        children.each(function(index) {
            var currentStyle = $(this).attr('style') ?? '';
            $(this).attr('style', currentStyle + '--position: ' + (index + 1) + ';');
        });
        $(this).find('.slide-holder').addClass('animation-loaded');
    });
});